export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/updatePhotoGalleryEventName',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['photogallerybyid'],
    })
